<template>
    <div class="layoutB">
        <!--主体呈现区-->
        <div class="layoutBContent">
            <slot name="layoutBContent"></slot>
        </div>
        <!--主体呈现区 end-->

        <!--弹窗组件区-->
        <div class="pageBlock" v-if="$slots.pageBlock && $slots.pageBlock.length">
            <slot name="pageBlock"></slot>
        </div>
        <!--弹窗组件区 end-->

        <!--密码修改-->
        <updatePassword ref="updatePassword"></updatePassword>

        <!--登录人详情-->
        <detailed ref="detailed"></detailed>

        <!--开发器-->
        <QHdev ref="QHdev"></QHdev>
    </div>
</template>

<script>
import Vue from 'vue'
import updatePassword from './block/updatePassword';
import detailed from './block/detailed';
export default {
    components: {
        updatePassword, detailed
    },
    data() {
        return {
            Dev: 0,
            authTree: this.$U.authTree,
            path: this.$route.path,
            user: this.$U
        }
    },
    mounted() {
        var that = this;
        //通过路径选择模块和下拉菜单(初始)
        if (!this.$isblank(that.authTree)) {
            let modifiedArray = that.authTree.map(item => {
                if (that.$isblank(item['children'])) {
                    return item;
                };
                if (item['children'].some(element => element.url == that.path)) {
                    that.blockId = item.blockId;
                    item.isOpen = 1;
                };
                return item;
            });
            that.authTree = modifiedArray;
        }

        //通过路径选择模块和下拉菜单(更新)
        that.getNowUserGobal(function (res) {
            localStorage.setItem("user", JSON.stringify(res));
            that.user = that.$jsonParse(localStorage.getItem("user"));
            Vue.prototype.$U = that.user;
            let modifiedArray = res.authTree.map(item => {
                if (that.$isblank(item['children'])) {
                    return item;
                };
                if (item['children'].some(element => element.url == that.path)) {
                    that.blockId = item.blockId;
                    item.isOpen = 1;
                };
                return item;
            });
            that.authTree = modifiedArray;
            Vue.prototype.$A = that.user.auth;
            if (that.$isblank(that.blockId)) {
                that.blockId = res.authBlock[0]['id'];
            };
        })
        this.isInIframe = this.$checkIfInIframe();

        //检测是否是开发模式
        if (this.$getLocalStorage('Dev') == 5) {
            this.Dev = 5;
        };
    },
    methods: {
        // +----------------------------------------------------------------------
        // | Desc:进入开发模式
        // +----------------------------------------------------------------------
        enterDev() {
            this.Dev = this.Dev + 1;
            if (this.Dev > 5) {
                this.Dev = 5;
            };
            if (this.Dev == 5) {
                this.$setLocalStorage('Dev', 5);
                this.Dev = 5;
            };
        },

        // +----------------------------------------------------------------------
        // | Desc:菜单的显示控制
        // +----------------------------------------------------------------------
        isMenuShow(item, level = 1) {
            if (item.type == 200) {
                return false;
            };
            if (level == 1) {
                if (item.blockId != this.blockId) {
                    return false;
                };
            }
            return true;
        },


        // +----------------------------------------------------------------------
        // | Desc:loginOut
        // +----------------------------------------------------------------------
        loginOut() {
            let that = this;
            this.$Modal.confirm({
                title: '退出登录提示',
                content: '<p>您确认要退出登录吗 ？</p>',
                onOk: () => {
                    localStorage.setItem("token", null);
                    localStorage.setItem("user", null);
                    that.$msg("成功退出登录", "success", 1000, function () {
                        that.$go("/login");
                    });
                }
            });
        },

        // +----------------------------------------------------------------------
        // | Desc:getNowUserGobal
        // +----------------------------------------------------------------------
        getNowUserGobal(callback) {
            let that = this;
            that.$api.getNowUserGobal({}).then((res) => {
                if (res.code == 0) {
                    callback(res.data);
                };
            });
        },


        // +----------------------------------------------------------------------
        // | Desc:rePassword
        // +----------------------------------------------------------------------
        rePassword() {
            this.$refs.updatePassword.hiUpdete();
        },


        // +----------------------------------------------------------------------
        // | Desc:detailed
        // +----------------------------------------------------------------------
        detailed() {
            this.$refs.detailed.hiPop();
        },

        // +----------------------------------------------------------------------
        // | Desc:blockTab
        // +----------------------------------------------------------------------
        blockTab(item) {
            this.blockId = item.id
        }


    },
}
</script>